{
  "tournament": {
    "name": "FIFA World Cup 2026",
    "starts_utc": "2026-06-11T00:00:00Z",
    "ends_utc": "2026-07-19T23:59:59Z",
    "name_es": "Copa Mundial de la FIFA 2026",
    "name_pt": "Copa do Mundo FIFA de 2026",
    "name_fr": "Coupe du Monde de la FIFA 2026",
    "name_ar": "كأس العالم فيفا ٢٠٢٦",
    "name_ja": "2026 FIFAワールドカップ",
    "name_de": "FIFA Weltmeisterschaft 2026"
  },
  "teams": [
    {
      "code": "MEX",
      "name_en": "Mexico",
      "flag_emoji": "🇲🇽",
      "group": "A",
      "name_es": "México",
      "name_pt": "México",
      "name_fr": "Mexique",
      "name_ar": "المكسيك",
      "name_ja": "メキシコ",
      "name_de": "Mexiko"
    },
    {
      "code": "RSA",
      "name_en": "South Africa",
      "flag_emoji": "🇿🇦",
      "group": "A",
      "name_es": "Sudáfrica",
      "name_pt": "África do Sul",
      "name_fr": "Afrique du Sud",
      "name_ar": "جنوب أفريقيا",
      "name_ja": "南アフリカ",
      "name_de": "Südafrika"
    },
    {
      "code": "KOR",
      "name_en": "South Korea",
      "flag_emoji": "🇰🇷",
      "group": "A",
      "name_es": "Corea del Sur",
      "name_pt": "Coreia do Sul",
      "name_fr": "Corée du Sud",
      "name_ar": "كوريا الجنوبية",
      "name_ja": "韓国",
      "name_de": "Südkorea"
    },
    {
      "code": "CZE",
      "name_en": "Czech Republic",
      "flag_emoji": "🇨🇿",
      "group": "A",
      "name_es": "República Checa",
      "name_pt": "República Checa",
      "name_fr": "République Tchèque",
      "name_ar": "جمهورية التشيك",
      "name_ja": "チェコ",
      "name_de": "Tschechien"
    },
    {
      "code": "CAN",
      "name_en": "Canada",
      "flag_emoji": "🇨🇦",
      "group": "B",
      "name_es": "Canadá",
      "name_pt": "Canadá",
      "name_fr": "Canada",
      "name_ar": "كندا",
      "name_ja": "カナダ",
      "name_de": "Kanada"
    },
    {
      "code": "BIH",
      "name_en": "Bosnia and Herzegovina",
      "flag_emoji": "🇧🇦",
      "group": "B",
      "name_es": "Bosnia y Herzegovina",
      "name_pt": "Bósnia e Herzegovina",
      "name_fr": "Bosnie-Herzégovine",
      "name_ar": "البوسنة والهرسك",
      "name_ja": "ボスニア・ヘルツェゴビナ",
      "name_de": "Bosnien und Herzegowina"
    },
    {
      "code": "QAT",
      "name_en": "Qatar",
      "flag_emoji": "🇶🇦",
      "group": "B",
      "name_es": "Catar",
      "name_pt": "Catar",
      "name_fr": "Qatar",
      "name_ar": "قطر",
      "name_ja": "カタール",
      "name_de": "Katar"
    },
    {
      "code": "SUI",
      "name_en": "Switzerland",
      "flag_emoji": "🇨🇭",
      "group": "B",
      "name_es": "Suiza",
      "name_pt": "Suíça",
      "name_fr": "Suisse",
      "name_ar": "سويسرا",
      "name_ja": "スイス",
      "name_de": "Schweiz"
    },
    {
      "code": "BRA",
      "name_en": "Brazil",
      "flag_emoji": "🇧🇷",
      "group": "C",
      "name_es": "Brasil",
      "name_pt": "Brasil",
      "name_fr": "Brésil",
      "name_ar": "البرازيل",
      "name_ja": "ブラジル",
      "name_de": "Brasilien"
    },
    {
      "code": "MAR",
      "name_en": "Morocco",
      "flag_emoji": "🇲🇦",
      "group": "C",
      "name_es": "Marruecos",
      "name_pt": "Marrocos",
      "name_fr": "Maroc",
      "name_ar": "المغرب",
      "name_ja": "モロッコ",
      "name_de": "Marokko"
    },
    {
      "code": "HAI",
      "name_en": "Haiti",
      "flag_emoji": "🇭🇹",
      "group": "C",
      "name_es": "Haití",
      "name_pt": "Haiti",
      "name_fr": "Haïti",
      "name_ar": "هايتي",
      "name_ja": "ハイチ",
      "name_de": "Haiti"
    },
    {
      "code": "SCO",
      "name_en": "Scotland",
      "flag_emoji": "🏴󠁧󠁢󠁳󠁣󠁴󠁿",
      "group": "C",
      "name_es": "Escocia",
      "name_pt": "Escócia",
      "name_fr": "Écosse",
      "name_ar": "اسكتلندا",
      "name_ja": "スコットランド",
      "name_de": "Schottland"
    },
    {
      "code": "USA",
      "name_en": "United States",
      "flag_emoji": "🇺🇸",
      "group": "D",
      "name_es": "Estados Unidos",
      "name_pt": "Estados Unidos",
      "name_fr": "États-Unis",
      "name_ar": "الولايات المتحدة",
      "name_ja": "アメリカ",
      "name_de": "USA"
    },
    {
      "code": "PAR",
      "name_en": "Paraguay",
      "flag_emoji": "🇵🇾",
      "group": "D",
      "name_es": "Paraguay",
      "name_pt": "Paraguai",
      "name_fr": "Paraguay",
      "name_ar": "باراغواي",
      "name_ja": "パラグアイ",
      "name_de": "Paraguay"
    },
    {
      "code": "AUS",
      "name_en": "Australia",
      "flag_emoji": "🇦🇺",
      "group": "D",
      "name_es": "Australia",
      "name_pt": "Austrália",
      "name_fr": "Australie",
      "name_ar": "أستراليا",
      "name_ja": "オーストラリア",
      "name_de": "Australien"
    },
    {
      "code": "TUR",
      "name_en": "Turkey",
      "flag_emoji": "🇹🇷",
      "group": "D",
      "name_es": "Turquía",
      "name_pt": "Turquia",
      "name_fr": "Turquie",
      "name_ar": "تركيا",
      "name_ja": "トルコ",
      "name_de": "Türkei"
    },
    {
      "code": "GER",
      "name_en": "Germany",
      "flag_emoji": "🇩🇪",
      "group": "E",
      "name_es": "Alemania",
      "name_pt": "Alemanha",
      "name_fr": "Allemagne",
      "name_ar": "ألمانيا",
      "name_ja": "ドイツ",
      "name_de": "Deutschland"
    },
    {
      "code": "CUW",
      "name_en": "Curaçao",
      "flag_emoji": "🇨🇼",
      "group": "E",
      "name_es": "Curazao",
      "name_pt": "Curaçao",
      "name_fr": "Curaçao",
      "name_ar": "كوراساو",
      "name_ja": "キュラソー",
      "name_de": "Curaçao"
    },
    {
      "code": "CIV",
      "name_en": "Ivory Coast",
      "flag_emoji": "🇨🇮",
      "group": "E",
      "name_es": "Costa de Marfil",
      "name_pt": "Costa do Marfim",
      "name_fr": "Côte d’Ivoire",
      "name_ar": "ساحل العاج",
      "name_ja": "コートジボワール",
      "name_de": "Elfenbeinküste"
    },
    {
      "code": "ECU",
      "name_en": "Ecuador",
      "flag_emoji": "🇪🇨",
      "group": "E",
      "name_es": "Ecuador",
      "name_pt": "Equador",
      "name_fr": "Équateur",
      "name_ar": "الإكوادور",
      "name_ja": "エクアドル",
      "name_de": "Ecuador"
    },
    {
      "code": "NED",
      "name_en": "Netherlands",
      "flag_emoji": "🇳🇱",
      "group": "F",
      "name_es": "Países Bajos",
      "name_pt": "Países Baixos",
      "name_fr": "Pays-Bas",
      "name_ar": "هولندا",
      "name_ja": "オランダ",
      "name_de": "Niederlande"
    },
    {
      "code": "JPN",
      "name_en": "Japan",
      "flag_emoji": "🇯🇵",
      "group": "F",
      "name_es": "Japón",
      "name_pt": "Japão",
      "name_fr": "Japon",
      "name_ar": "اليابان",
      "name_ja": "日本",
      "name_de": "Japan"
    },
    {
      "code": "SWE",
      "name_en": "Sweden",
      "flag_emoji": "🇸🇪",
      "group": "F",
      "name_es": "Suecia",
      "name_pt": "Suécia",
      "name_fr": "Suède",
      "name_ar": "السويد",
      "name_ja": "スウェーデン",
      "name_de": "Schweden"
    },
    {
      "code": "TUN",
      "name_en": "Tunisia",
      "flag_emoji": "🇹🇳",
      "group": "F",
      "name_es": "Túnez",
      "name_pt": "Tunísia",
      "name_fr": "Tunisie",
      "name_ar": "تونس",
      "name_ja": "チュニジア",
      "name_de": "Tunesien"
    },
    {
      "code": "BEL",
      "name_en": "Belgium",
      "flag_emoji": "🇧🇪",
      "group": "G",
      "name_es": "Bélgica",
      "name_pt": "Bélgica",
      "name_fr": "Belgique",
      "name_ar": "بلجيكا",
      "name_ja": "ベルギー",
      "name_de": "Belgien"
    },
    {
      "code": "EGY",
      "name_en": "Egypt",
      "flag_emoji": "🇪🇬",
      "group": "G",
      "name_es": "Egipto",
      "name_pt": "Egito",
      "name_fr": "Égypte",
      "name_ar": "مصر",
      "name_ja": "エジプト",
      "name_de": "Ägypten"
    },
    {
      "code": "IRN",
      "name_en": "Iran",
      "flag_emoji": "🇮🇷",
      "group": "G",
      "name_es": "Irán",
      "name_pt": "Irã",
      "name_fr": "Iran",
      "name_ar": "إيران",
      "name_ja": "イラン",
      "name_de": "Iran"
    },
    {
      "code": "NZL",
      "name_en": "New Zealand",
      "flag_emoji": "🇳🇿",
      "group": "G",
      "name_es": "Nueva Zelanda",
      "name_pt": "Nova Zelândia",
      "name_fr": "Nouvelle-Zélande",
      "name_ar": "نيوزيلندا",
      "name_ja": "ニュージーランド",
      "name_de": "Neuseeland"
    },
    {
      "code": "ESP",
      "name_en": "Spain",
      "flag_emoji": "🇪🇸",
      "group": "H",
      "name_es": "España",
      "name_pt": "Espanha",
      "name_fr": "Espagne",
      "name_ar": "إسبانيا",
      "name_ja": "スペイン",
      "name_de": "Spanien"
    },
    {
      "code": "CPV",
      "name_en": "Cape Verde",
      "flag_emoji": "🇨🇻",
      "group": "H",
      "name_es": "Cabo Verde",
      "name_pt": "Cabo Verde",
      "name_fr": "Cap-Vert",
      "name_ar": "الرأس الأخضر",
      "name_ja": "カーボベルデ",
      "name_de": "Kap Verde"
    },
    {
      "code": "KSA",
      "name_en": "Saudi Arabia",
      "flag_emoji": "🇸🇦",
      "group": "H",
      "name_es": "Arabia Saudita",
      "name_pt": "Arábia Saudita",
      "name_fr": "Arabie Saoudite",
      "name_ar": "المملكة العربية السعودية",
      "name_ja": "サウジアラビア",
      "name_de": "Saudi-Arabien"
    },
    {
      "code": "URU",
      "name_en": "Uruguay",
      "flag_emoji": "🇺🇾",
      "group": "H",
      "name_es": "Uruguay",
      "name_pt": "Uruguai",
      "name_fr": "Uruguay",
      "name_ar": "أوروغواي",
      "name_ja": "ウルグアイ",
      "name_de": "Uruguay"
    },
    {
      "code": "FRA",
      "name_en": "France",
      "flag_emoji": "🇫🇷",
      "group": "I",
      "name_es": "Francia",
      "name_pt": "França",
      "name_fr": "France",
      "name_ar": "فرنسا",
      "name_ja": "フランス",
      "name_de": "Frankreich"
    },
    {
      "code": "SEN",
      "name_en": "Senegal",
      "flag_emoji": "🇸🇳",
      "group": "I",
      "name_es": "Senegal",
      "name_pt": "Senegal",
      "name_fr": "Sénégal",
      "name_ar": "السنغال",
      "name_ja": "セネガル",
      "name_de": "Senegal"
    },
    {
      "code": "IRQ",
      "name_en": "Iraq",
      "flag_emoji": "🇮🇶",
      "group": "I",
      "name_es": "Irak",
      "name_pt": "Iraque",
      "name_fr": "Irak",
      "name_ar": "العراق",
      "name_ja": "イラク",
      "name_de": "Irak"
    },
    {
      "code": "NOR",
      "name_en": "Norway",
      "flag_emoji": "🇳🇴",
      "group": "I",
      "name_es": "Noruega",
      "name_pt": "Noruega",
      "name_fr": "Norvège",
      "name_ar": "النرويج",
      "name_ja": "ノルウェー",
      "name_de": "Norwegen"
    },
    {
      "code": "ARG",
      "name_en": "Argentina",
      "flag_emoji": "🇦🇷",
      "group": "J",
      "name_es": "Argentina",
      "name_pt": "Argentina",
      "name_fr": "Argentine",
      "name_ar": "الأرجنتين",
      "name_ja": "アルゼンチン",
      "name_de": "Argentinien"
    },
    {
      "code": "ALG",
      "name_en": "Algeria",
      "flag_emoji": "🇩🇿",
      "group": "J",
      "name_es": "Argelia",
      "name_pt": "Argélia",
      "name_fr": "Algérie",
      "name_ar": "الجزائر",
      "name_ja": "アルジェリア",
      "name_de": "Algerien"
    },
    {
      "code": "AUT",
      "name_en": "Austria",
      "flag_emoji": "🇦🇹",
      "group": "J",
      "name_es": "Austria",
      "name_pt": "Áustria",
      "name_fr": "Autriche",
      "name_ar": "النمسا",
      "name_ja": "オーストリア",
      "name_de": "Österreich"
    },
    {
      "code": "JOR",
      "name_en": "Jordan",
      "flag_emoji": "🇯🇴",
      "group": "J",
      "name_es": "Jordania",
      "name_pt": "Jordânia",
      "name_fr": "Jordanie",
      "name_ar": "الأردن",
      "name_ja": "ヨルダン",
      "name_de": "Jordanien"
    },
    {
      "code": "POR",
      "name_en": "Portugal",
      "flag_emoji": "🇵🇹",
      "group": "K",
      "name_es": "Portugal",
      "name_pt": "Portugal",
      "name_fr": "Portugal",
      "name_ar": "البرتغال",
      "name_ja": "ポルトガル",
      "name_de": "Portugal"
    },
    {
      "code": "COD",
      "name_en": "DR Congo",
      "flag_emoji": "🇨🇩",
      "group": "K",
      "name_es": "RD Congo",
      "name_pt": "RD Congo",
      "name_fr": "RD Congo",
      "name_ar": "جمهورية الكونغو الديمقراطية",
      "name_ja": "コンゴ民主共和国",
      "name_de": "DR Kongo"
    },
    {
      "code": "UZB",
      "name_en": "Uzbekistan",
      "flag_emoji": "🇺🇿",
      "group": "K",
      "name_es": "Uzbekistán",
      "name_pt": "Uzbequistão",
      "name_fr": "Ouzbékistan",
      "name_ar": "أوزبكستان",
      "name_ja": "ウズベキスタン",
      "name_de": "Usbekistan"
    },
    {
      "code": "COL",
      "name_en": "Colombia",
      "flag_emoji": "🇨🇴",
      "group": "K",
      "name_es": "Colombia",
      "name_pt": "Colômbia",
      "name_fr": "Colombie",
      "name_ar": "كولومبيا",
      "name_ja": "コロンビア",
      "name_de": "Kolumbien"
    },
    {
      "code": "ENG",
      "name_en": "England",
      "flag_emoji": "🏴󠁧󠁢󠁥󠁮󠁧󠁿",
      "group": "L",
      "name_es": "Inglaterra",
      "name_pt": "Inglaterra",
      "name_fr": "Angleterre",
      "name_ar": "إنجلترا",
      "name_ja": "イングランド",
      "name_de": "England"
    },
    {
      "code": "CRO",
      "name_en": "Croatia",
      "flag_emoji": "🇭🇷",
      "group": "L",
      "name_es": "Croacia",
      "name_pt": "Croácia",
      "name_fr": "Croatie",
      "name_ar": "كرواتيا",
      "name_ja": "クロアチア",
      "name_de": "Kroatien"
    },
    {
      "code": "GHA",
      "name_en": "Ghana",
      "flag_emoji": "🇬🇭",
      "group": "L",
      "name_es": "Ghana",
      "name_pt": "Gana",
      "name_fr": "Ghana",
      "name_ar": "غانا",
      "name_ja": "ガーナ",
      "name_de": "Ghana"
    },
    {
      "code": "PAN",
      "name_en": "Panama",
      "flag_emoji": "🇵🇦",
      "group": "L",
      "name_es": "Panamá",
      "name_pt": "Panamá",
      "name_fr": "Panama",
      "name_ar": "بنما",
      "name_ja": "パナマ",
      "name_de": "Panama"
    }
  ],
  "venues": [
    {
      "id": "azteca-mexico-city",
      "name": "Estadio Azteca",
      "city": "Mexico City",
      "country": "Mexico",
      "name_es": "Estadio Azteca",
      "name_pt": "Estádio Azteca",
      "name_fr": "Stade Azteca",
      "name_ar": "ملعب أزتيكا",
      "city_es": "Ciudad de México",
      "city_pt": "Cidade do México",
      "city_fr": "Mexico",
      "city_ar": "مدينة مكسيكو",
      "name_ja": "エスタディオ・アステカ",
      "city_ja": "メキシコシティ",
      "tz": "America/Mexico_City"
    },
    {
      "id": "akron-guadalajara",
      "name": "Estadio Akron",
      "city": "Guadalajara",
      "country": "Mexico",
      "name_es": "Estadio Akron",
      "name_pt": "Estádio Akron",
      "name_fr": "Stade Akron",
      "name_ar": "ملعب أكرون",
      "city_es": "Guadalajara",
      "city_pt": "Guadalajara",
      "city_fr": "Guadalajara",
      "city_ar": "غوادالاخارا",
      "name_ja": "エスタディオ・アクロン",
      "city_ja": "グアダラハラ",
      "tz": "America/Mexico_City"
    },
    {
      "id": "bbva-monterrey",
      "name": "Estadio BBVA",
      "city": "Monterrey",
      "country": "Mexico",
      "name_es": "Estadio BBVA",
      "name_pt": "Estádio BBVA",
      "name_fr": "Stade BBVA",
      "name_ar": "ملعب بي بي في ايه",
      "city_es": "Monterrey",
      "city_pt": "Monterrey",
      "city_fr": "Monterrey",
      "city_ar": "مونتيري",
      "name_ja": "エスタディオ・BBVA",
      "city_ja": "モンテレイ",
      "tz": "America/Monterrey"
    },
    {
      "id": "metlife-east-rutherford",
      "name": "MetLife Stadium",
      "city": "East Rutherford",
      "country": "USA",
      "name_es": "MetLife Stadium",
      "name_pt": "MetLife Stadium",
      "name_fr": "Stade MetLife",
      "name_ar": "ملعب ميتلايف",
      "city_es": "East Rutherford",
      "city_pt": "East Rutherford",
      "city_fr": "East Rutherford",
      "city_ar": "إيست روذرفورد",
      "name_ja": "メットライフ・スタジアム",
      "city_ja": "イーストラザフォード",
      "tz": "America/New_York"
    },
    {
      "id": "sofi-inglewood",
      "name": "SoFi Stadium",
      "city": "Inglewood",
      "country": "USA",
      "name_es": "SoFi Stadium",
      "name_pt": "SoFi Stadium",
      "name_fr": "Stade SoFi",
      "name_ar": "ملعب سوفي",
      "city_es": "Inglewood",
      "city_pt": "Inglewood",
      "city_fr": "Inglewood",
      "city_ar": "إنجلوود",
      "name_ja": "SoFiスタジアム",
      "city_ja": "イングルウッド",
      "tz": "America/Los_Angeles"
    },
    {
      "id": "att-arlington",
      "name": "AT&T Stadium",
      "city": "Arlington",
      "country": "USA",
      "name_es": "AT&T Stadium",
      "name_pt": "AT&T Stadium",
      "name_fr": "Stade AT&T",
      "name_ar": "ملعب إي تي آند تي",
      "city_es": "Arlington",
      "city_pt": "Arlington",
      "city_fr": "Arlington",
      "city_ar": "أرلينغتون",
      "name_ja": "AT&Tスタジアム",
      "city_ja": "アーリントン",
      "tz": "America/Chicago"
    },
    {
      "id": "nrg-houston",
      "name": "NRG Stadium",
      "city": "Houston",
      "country": "USA",
      "name_es": "NRG Stadium",
      "name_pt": "NRG Stadium",
      "name_fr": "Stade NRG",
      "name_ar": "ملعب إن آر جي",
      "city_es": "Houston",
      "city_pt": "Houston",
      "city_fr": "Houston",
      "city_ar": "هيوسطن",
      "name_ja": "NRGスタジアム",
      "city_ja": "ヒューストン",
      "tz": "America/Chicago"
    },
    {
      "id": "mercedes-benz-atlanta",
      "name": "Mercedes-Benz Stadium",
      "city": "Atlanta",
      "country": "USA",
      "name_es": "Mercedes-Benz Stadium",
      "name_pt": "Mercedes-Benz Stadium",
      "name_fr": "Stade Mercedes-Benz",
      "name_ar": "ملعب مرسيدس بنز",
      "city_es": "Atlanta",
      "city_pt": "Atlanta",
      "city_fr": "Atlanta",
      "city_ar": "أتلانتا",
      "name_ja": "メルセデス・ベンツ・スタジアム",
      "city_ja": "アトランタ",
      "tz": "America/New_York"
    },
    {
      "id": "gillette-foxborough",
      "name": "Gillette Stadium",
      "city": "Foxborough",
      "country": "USA",
      "name_es": "Gillette Stadium",
      "name_pt": "Gillette Stadium",
      "name_fr": "Stade Gillette",
      "name_ar": "ملعب جيليت",
      "city_es": "Foxborough",
      "city_pt": "Foxborough",
      "city_fr": "Foxborough",
      "city_ar": "فوكسبورو",
      "name_ja": "ジレット・スタジアム",
      "city_ja": "フォックスボロ",
      "tz": "America/New_York"
    },
    {
      "id": "levi-santa-clara",
      "name": "Levi's Stadium",
      "city": "Santa Clara",
      "country": "USA",
      "name_es": "Levi's Stadium",
      "name_pt": "Levi's Stadium",
      "name_fr": "Stade Levi's",
      "name_ar": "ملعب ليفي",
      "city_es": "Santa Clara",
      "city_pt": "Santa Clara",
      "city_fr": "Santa Clara",
      "city_ar": "سانتا كلارا",
      "name_ja": "リーバイス・スタジアム",
      "city_ja": "サンタクララ",
      "tz": "America/Los_Angeles"
    },
    {
      "id": "arrowhead-kansas-city",
      "name": "Arrowhead Stadium",
      "city": "Kansas City",
      "country": "USA",
      "name_es": "Arrowhead Stadium",
      "name_pt": "Arrowhead Stadium",
      "name_fr": "Stade Arrowhead",
      "name_ar": "ملعب أروهيد",
      "city_es": "Kansas City",
      "city_pt": "Kansas City",
      "city_fr": "Kansas City",
      "city_ar": "كانساس سيتي",
      "name_ja": "アローヘッド・スタジアム",
      "city_ja": "カンザスシティ",
      "tz": "America/Chicago"
    },
    {
      "id": "lincoln-philadelphia",
      "name": "Lincoln Financial Field",
      "city": "Philadelphia",
      "country": "USA",
      "name_es": "Lincoln Financial Field",
      "name_pt": "Lincoln Financial Field",
      "name_fr": "Lincoln Financial Field",
      "name_ar": "ملعب لينكون فاينانشال فيلد",
      "city_es": "Filadelfia",
      "city_pt": "Filadélfia",
      "city_fr": "Philadelphie",
      "city_ar": "فيلادلفيا",
      "name_ja": "リンカーン・フィナンシャル・フィールド",
      "city_ja": "フィラデルフィア",
      "tz": "America/New_York"
    },
    {
      "id": "hard-rock-miami",
      "name": "Hard Rock Stadium",
      "city": "Miami",
      "country": "USA",
      "name_es": "Hard Rock Stadium",
      "name_pt": "Hard Rock Stadium",
      "name_fr": "Stade Hard Rock",
      "name_ar": "ملعب هارد روك",
      "city_es": "Miami",
      "city_pt": "Miami",
      "city_fr": "Miami",
      "city_ar": "ميامي",
      "name_ja": "ハードロック・スタジアム",
      "city_ja": "マイアミ",
      "tz": "America/New_York"
    },
    {
      "id": "century-link-seattle",
      "name": "Lumen Field",
      "city": "Seattle",
      "country": "USA",
      "name_es": "Lumen Field",
      "name_pt": "Lumen Field",
      "name_fr": "Lumen Field",
      "name_ar": "ملعب لومن فيلد",
      "city_es": "Seattle",
      "city_pt": "Seattle",
      "city_fr": "Seattle",
      "city_ar": "سياتل",
      "name_ja": "ルーメン・フィールド",
      "city_ja": "シアトル",
      "tz": "America/Los_Angeles"
    },
    {
      "id": "bmo-toronto",
      "name": "BMO Field",
      "city": "Toronto",
      "country": "Canada",
      "name_es": "BMO Field",
      "name_pt": "BMO Field",
      "name_fr": "BMO Field",
      "name_ar": "ملعب بي إم أو",
      "city_es": "Toronto",
      "city_pt": "Toronto",
      "city_fr": "Toronto",
      "city_ar": "تورونتو",
      "name_ja": "BMOフィールド",
      "city_ja": "トロント",
      "tz": "America/Toronto"
    },
    {
      "id": "bc-place-vancouver",
      "name": "BC Place",
      "city": "Vancouver",
      "country": "Canada",
      "name_es": "BC Place",
      "name_pt": "BC Place",
      "name_fr": "BC Place",
      "name_ar": "بي سي بليس",
      "city_es": "Vancouver",
      "city_pt": "Vancouver",
      "city_fr": "Vancouver",
      "city_ar": "فانكوفر",
      "name_ja": "BCプレイス",
      "city_ja": "バンクーバー",
      "tz": "America/Vancouver"
    }
  ],
  "matches": [
    {
      "id": "wc26-m001",
      "stage": "group",
      "group": "A",
      "kickoff_utc": "2026-06-11T19:00:00Z",
      "venue_id": "azteca-mexico-city",
      "home": "MEX",
      "away": "RSA",
      "revision": 1,
      "score": "2-0"
    },
    {
      "id": "wc26-m002",
      "stage": "group",
      "group": "A",
      "kickoff_utc": "2026-06-12T02:00:00Z",
      "venue_id": "akron-guadalajara",
      "home": "KOR",
      "away": "CZE",
      "revision": 1,
      "score": "2-1"
    },
    {
      "id": "wc26-m003",
      "stage": "group",
      "group": "A",
      "kickoff_utc": "2026-06-19T01:00:00Z",
      "venue_id": "akron-guadalajara",
      "home": "MEX",
      "away": "KOR",
      "revision": 1,
      "score": "1-0"
    },
    {
      "id": "wc26-m004",
      "stage": "group",
      "group": "A",
      "kickoff_utc": "2026-06-18T16:00:00Z",
      "venue_id": "mercedes-benz-atlanta",
      "home": "RSA",
      "away": "CZE",
      "revision": 1,
      "score": "1-1"
    },
    {
      "id": "wc26-m005",
      "stage": "group",
      "group": "A",
      "kickoff_utc": "2026-06-25T01:00:00Z",
      "venue_id": "azteca-mexico-city",
      "home": "CZE",
      "away": "MEX",
      "revision": 1,
      "score": "0-3"
    },
    {
      "id": "wc26-m006",
      "stage": "group",
      "group": "A",
      "kickoff_utc": "2026-06-25T01:00:00Z",
      "venue_id": "bbva-monterrey",
      "home": "RSA",
      "away": "KOR",
      "revision": 1,
      "score": "1-0"
    },
    {
      "id": "wc26-m007",
      "stage": "group",
      "group": "B",
      "kickoff_utc": "2026-06-12T19:00:00Z",
      "venue_id": "bmo-toronto",
      "home": "CAN",
      "away": "BIH",
      "revision": 1,
      "score": "1-1"
    },
    {
      "id": "wc26-m008",
      "stage": "group",
      "group": "B",
      "kickoff_utc": "2026-06-13T19:00:00Z",
      "venue_id": "levi-santa-clara",
      "home": "QAT",
      "away": "SUI",
      "revision": 1,
      "score": "1-1"
    },
    {
      "id": "wc26-m009",
      "stage": "group",
      "group": "B",
      "kickoff_utc": "2026-06-18T22:00:00Z",
      "venue_id": "bc-place-vancouver",
      "home": "CAN",
      "away": "QAT",
      "revision": 1,
      "score": "6-0"
    },
    {
      "id": "wc26-m010",
      "stage": "group",
      "group": "B",
      "kickoff_utc": "2026-06-18T19:00:00Z",
      "venue_id": "sofi-inglewood",
      "home": "BIH",
      "away": "SUI",
      "revision": 1,
      "score": "1-4"
    },
    {
      "id": "wc26-m011",
      "stage": "group",
      "group": "B",
      "kickoff_utc": "2026-06-24T19:00:00Z",
      "venue_id": "bc-place-vancouver",
      "home": "SUI",
      "away": "CAN",
      "revision": 1,
      "score": "2-1"
    },
    {
      "id": "wc26-m012",
      "stage": "group",
      "group": "B",
      "kickoff_utc": "2026-06-24T19:00:00Z",
      "venue_id": "century-link-seattle",
      "home": "BIH",
      "away": "QAT",
      "revision": 1,
      "score": "3-1"
    },
    {
      "id": "wc26-m013",
      "stage": "group",
      "group": "C",
      "kickoff_utc": "2026-06-13T22:00:00Z",
      "venue_id": "metlife-east-rutherford",
      "home": "BRA",
      "away": "MAR",
      "revision": 1,
      "score": "1-1"
    },
    {
      "id": "wc26-m014",
      "stage": "group",
      "group": "C",
      "kickoff_utc": "2026-06-14T01:00:00Z",
      "venue_id": "gillette-foxborough",
      "home": "HAI",
      "away": "SCO",
      "revision": 1,
      "score": "0-1"
    },
    {
      "id": "wc26-m015",
      "stage": "group",
      "group": "C",
      "kickoff_utc": "2026-06-20T00:30:00Z",
      "venue_id": "lincoln-philadelphia",
      "home": "BRA",
      "away": "HAI",
      "revision": 1,
      "score": "3-0"
    },
    {
      "id": "wc26-m016",
      "stage": "group",
      "group": "C",
      "kickoff_utc": "2026-06-19T22:00:00Z",
      "venue_id": "gillette-foxborough",
      "home": "MAR",
      "away": "SCO",
      "revision": 1,
      "score": "1-0"
    },
    {
      "id": "wc26-m017",
      "stage": "group",
      "group": "C",
      "kickoff_utc": "2026-06-24T22:00:00Z",
      "venue_id": "hard-rock-miami",
      "home": "SCO",
      "away": "BRA",
      "revision": 1,
      "score": "0-3"
    },
    {
      "id": "wc26-m018",
      "stage": "group",
      "group": "C",
      "kickoff_utc": "2026-06-24T22:00:00Z",
      "venue_id": "mercedes-benz-atlanta",
      "home": "MAR",
      "away": "HAI",
      "revision": 1,
      "score": "4-2"
    },
    {
      "id": "wc26-m019",
      "stage": "group",
      "group": "D",
      "kickoff_utc": "2026-06-13T01:00:00Z",
      "venue_id": "sofi-inglewood",
      "home": "USA",
      "away": "PAR",
      "revision": 1,
      "score": "4-1"
    },
    {
      "id": "wc26-m020",
      "stage": "group",
      "group": "D",
      "kickoff_utc": "2026-06-14T16:00:00Z",
      "venue_id": "bc-place-vancouver",
      "home": "AUS",
      "away": "TUR",
      "revision": 1,
      "score": "2-0"
    },
    {
      "id": "wc26-m021",
      "stage": "group",
      "group": "D",
      "kickoff_utc": "2026-06-19T19:00:00Z",
      "venue_id": "century-link-seattle",
      "home": "USA",
      "away": "AUS",
      "revision": 1,
      "score": "2-0"
    },
    {
      "id": "wc26-m022",
      "stage": "group",
      "group": "D",
      "kickoff_utc": "2026-06-20T03:00:00Z",
      "venue_id": "levi-santa-clara",
      "home": "PAR",
      "away": "TUR",
      "revision": 1,
      "score": "1-0"
    },
    {
      "id": "wc26-m023",
      "stage": "group",
      "group": "D",
      "kickoff_utc": "2026-06-26T02:00:00Z",
      "venue_id": "sofi-inglewood",
      "home": "TUR",
      "away": "USA",
      "revision": 1,
      "score": "3-2"
    },
    {
      "id": "wc26-m024",
      "stage": "group",
      "group": "D",
      "kickoff_utc": "2026-06-26T02:00:00Z",
      "venue_id": "levi-santa-clara",
      "home": "PAR",
      "away": "AUS",
      "revision": 1,
      "score": "0-0"
    },
    {
      "id": "wc26-m025",
      "stage": "group",
      "group": "E",
      "kickoff_utc": "2026-06-14T17:00:00Z",
      "venue_id": "nrg-houston",
      "home": "GER",
      "away": "CUW",
      "revision": 1,
      "score": "7-1"
    },
    {
      "id": "wc26-m026",
      "stage": "group",
      "group": "E",
      "kickoff_utc": "2026-06-14T23:00:00Z",
      "venue_id": "lincoln-philadelphia",
      "home": "CIV",
      "away": "ECU",
      "revision": 1,
      "score": "1-0"
    },
    {
      "id": "wc26-m027",
      "stage": "group",
      "group": "E",
      "kickoff_utc": "2026-06-20T20:00:00Z",
      "venue_id": "bmo-toronto",
      "home": "GER",
      "away": "CIV",
      "revision": 1,
      "score": "2-1"
    },
    {
      "id": "wc26-m028",
      "stage": "group",
      "group": "E",
      "kickoff_utc": "2026-06-21T00:00:00Z",
      "venue_id": "arrowhead-kansas-city",
      "home": "CUW",
      "away": "ECU",
      "revision": 1,
      "score": "0-0"
    },
    {
      "id": "wc26-m029",
      "stage": "group",
      "group": "E",
      "kickoff_utc": "2026-06-25T20:00:00Z",
      "venue_id": "metlife-east-rutherford",
      "home": "ECU",
      "away": "GER",
      "revision": 1,
      "score": "2-1"
    },
    {
      "id": "wc26-m030",
      "stage": "group",
      "group": "E",
      "kickoff_utc": "2026-06-25T20:00:00Z",
      "venue_id": "lincoln-philadelphia",
      "home": "CUW",
      "away": "CIV",
      "revision": 1,
      "score": "0-2"
    },
    {
      "id": "wc26-m031",
      "stage": "group",
      "group": "F",
      "kickoff_utc": "2026-06-14T20:00:00Z",
      "venue_id": "att-arlington",
      "home": "NED",
      "away": "JPN",
      "revision": 1,
      "score": "2-2"
    },
    {
      "id": "wc26-m032",
      "stage": "group",
      "group": "F",
      "kickoff_utc": "2026-06-15T02:00:00Z",
      "venue_id": "bbva-monterrey",
      "home": "SWE",
      "away": "TUN",
      "revision": 1,
      "score": "5-1"
    },
    {
      "id": "wc26-m033",
      "stage": "group",
      "group": "F",
      "kickoff_utc": "2026-06-20T17:00:00Z",
      "venue_id": "nrg-houston",
      "home": "NED",
      "away": "SWE",
      "revision": 1,
      "score": "5-1"
    },
    {
      "id": "wc26-m034",
      "stage": "group",
      "group": "F",
      "kickoff_utc": "2026-06-21T04:00:00Z",
      "venue_id": "bbva-monterrey",
      "home": "JPN",
      "away": "TUN",
      "revision": 1,
      "score": "4-0"
    },
    {
      "id": "wc26-m035",
      "stage": "group",
      "group": "F",
      "kickoff_utc": "2026-06-25T23:00:00Z",
      "venue_id": "arrowhead-kansas-city",
      "home": "TUN",
      "away": "NED",
      "revision": 1,
      "score": "1-3"
    },
    {
      "id": "wc26-m036",
      "stage": "group",
      "group": "F",
      "kickoff_utc": "2026-06-25T23:00:00Z",
      "venue_id": "att-arlington",
      "home": "JPN",
      "away": "SWE",
      "revision": 1,
      "score": "1-1"
    },
    {
      "id": "wc26-m037",
      "stage": "group",
      "group": "G",
      "kickoff_utc": "2026-06-15T19:00:00Z",
      "venue_id": "century-link-seattle",
      "home": "BEL",
      "away": "EGY",
      "revision": 1,
      "score": "1-1"
    },
    {
      "id": "wc26-m038",
      "stage": "group",
      "group": "G",
      "kickoff_utc": "2026-06-16T01:00:00Z",
      "venue_id": "sofi-inglewood",
      "home": "IRN",
      "away": "NZL",
      "revision": 1,
      "score": "2-2"
    },
    {
      "id": "wc26-m039",
      "stage": "group",
      "group": "G",
      "kickoff_utc": "2026-06-21T19:00:00Z",
      "venue_id": "sofi-inglewood",
      "home": "BEL",
      "away": "IRN",
      "revision": 1,
      "score": "0-0"
    },
    {
      "id": "wc26-m040",
      "stage": "group",
      "group": "G",
      "kickoff_utc": "2026-06-22T01:00:00Z",
      "venue_id": "bc-place-vancouver",
      "home": "EGY",
      "away": "NZL",
      "revision": 1,
      "score": "3-1"
    },
    {
      "id": "wc26-m041",
      "stage": "group",
      "group": "G",
      "kickoff_utc": "2026-06-27T03:00:00Z",
      "venue_id": "bc-place-vancouver",
      "home": "NZL",
      "away": "BEL",
      "revision": 1,
      "score": "1-5"
    },
    {
      "id": "wc26-m042",
      "stage": "group",
      "group": "G",
      "kickoff_utc": "2026-06-27T03:00:00Z",
      "venue_id": "century-link-seattle",
      "home": "EGY",
      "away": "IRN",
      "revision": 3,
      "score": "1-1"
    },
    {
      "id": "wc26-m043",
      "stage": "group",
      "group": "H",
      "kickoff_utc": "2026-06-15T16:00:00Z",
      "venue_id": "mercedes-benz-atlanta",
      "home": "ESP",
      "away": "CPV",
      "revision": 1,
      "score": "0-0"
    },
    {
      "id": "wc26-m044",
      "stage": "group",
      "group": "H",
      "kickoff_utc": "2026-06-15T22:00:00Z",
      "venue_id": "hard-rock-miami",
      "home": "KSA",
      "away": "URU",
      "revision": 1,
      "score": "1-1"
    },
    {
      "id": "wc26-m045",
      "stage": "group",
      "group": "H",
      "kickoff_utc": "2026-06-21T16:00:00Z",
      "venue_id": "mercedes-benz-atlanta",
      "home": "ESP",
      "away": "KSA",
      "revision": 1,
      "score": "4-0"
    },
    {
      "id": "wc26-m046",
      "stage": "group",
      "group": "H",
      "kickoff_utc": "2026-06-21T22:00:00Z",
      "venue_id": "hard-rock-miami",
      "home": "CPV",
      "away": "URU",
      "revision": 1,
      "score": "2-2"
    },
    {
      "id": "wc26-m047",
      "stage": "group",
      "group": "H",
      "kickoff_utc": "2026-06-27T00:00:00Z",
      "venue_id": "akron-guadalajara",
      "home": "URU",
      "away": "ESP",
      "revision": 1,
      "score": "0-1"
    },
    {
      "id": "wc26-m048",
      "stage": "group",
      "group": "H",
      "kickoff_utc": "2026-06-27T00:00:00Z",
      "venue_id": "nrg-houston",
      "home": "CPV",
      "away": "KSA",
      "revision": 1,
      "score": "0-0"
    },
    {
      "id": "wc26-m049",
      "stage": "group",
      "group": "I",
      "kickoff_utc": "2026-06-16T19:00:00Z",
      "venue_id": "metlife-east-rutherford",
      "home": "FRA",
      "away": "SEN",
      "revision": 1,
      "score": "3-1"
    },
    {
      "id": "wc26-m050",
      "stage": "group",
      "group": "I",
      "kickoff_utc": "2026-06-16T22:00:00Z",
      "venue_id": "gillette-foxborough",
      "home": "IRQ",
      "away": "NOR",
      "revision": 1,
      "score": "1-4"
    },
    {
      "id": "wc26-m051",
      "stage": "group",
      "group": "I",
      "kickoff_utc": "2026-06-22T21:00:00Z",
      "venue_id": "lincoln-philadelphia",
      "home": "FRA",
      "away": "IRQ",
      "revision": 1,
      "score": "3-0"
    },
    {
      "id": "wc26-m052",
      "stage": "group",
      "group": "I",
      "kickoff_utc": "2026-06-23T00:00:00Z",
      "venue_id": "metlife-east-rutherford",
      "home": "SEN",
      "away": "NOR",
      "revision": 1,
      "score": "2-3"
    },
    {
      "id": "wc26-m053",
      "stage": "group",
      "group": "I",
      "kickoff_utc": "2026-06-26T19:00:00Z",
      "venue_id": "gillette-foxborough",
      "home": "NOR",
      "away": "FRA",
      "revision": 1,
      "score": "1-4"
    },
    {
      "id": "wc26-m054",
      "stage": "group",
      "group": "I",
      "kickoff_utc": "2026-06-26T19:00:00Z",
      "venue_id": "bmo-toronto",
      "home": "SEN",
      "away": "IRQ",
      "revision": 1,
      "score": "5-0"
    },
    {
      "id": "wc26-m055",
      "stage": "group",
      "group": "J",
      "kickoff_utc": "2026-06-17T01:00:00Z",
      "venue_id": "arrowhead-kansas-city",
      "home": "ARG",
      "away": "ALG",
      "revision": 1,
      "score": "3-0"
    },
    {
      "id": "wc26-m056",
      "stage": "group",
      "group": "J",
      "kickoff_utc": "2026-06-17T04:00:00Z",
      "venue_id": "levi-santa-clara",
      "home": "AUT",
      "away": "JOR",
      "revision": 1,
      "score": "3-1"
    },
    {
      "id": "wc26-m057",
      "stage": "group",
      "group": "J",
      "kickoff_utc": "2026-06-22T17:00:00Z",
      "venue_id": "att-arlington",
      "home": "ARG",
      "away": "AUT",
      "revision": 1,
      "score": "2-0"
    },
    {
      "id": "wc26-m058",
      "stage": "group",
      "group": "J",
      "kickoff_utc": "2026-06-23T03:00:00Z",
      "venue_id": "levi-santa-clara",
      "home": "ALG",
      "away": "JOR",
      "revision": 1,
      "score": "2-1"
    },
    {
      "id": "wc26-m059",
      "stage": "group",
      "group": "J",
      "kickoff_utc": "2026-06-28T02:00:00Z",
      "venue_id": "att-arlington",
      "home": "JOR",
      "away": "ARG",
      "revision": 1,
      "score": "1-3"
    },
    {
      "id": "wc26-m060",
      "stage": "group",
      "group": "J",
      "kickoff_utc": "2026-06-28T02:00:00Z",
      "venue_id": "arrowhead-kansas-city",
      "home": "ALG",
      "away": "AUT",
      "revision": 1,
      "score": "3-3"
    },
    {
      "id": "wc26-m061",
      "stage": "group",
      "group": "K",
      "kickoff_utc": "2026-06-17T17:00:00Z",
      "venue_id": "nrg-houston",
      "home": "POR",
      "away": "COD",
      "revision": 1,
      "score": "1-1"
    },
    {
      "id": "wc26-m062",
      "stage": "group",
      "group": "K",
      "kickoff_utc": "2026-06-18T02:00:00Z",
      "venue_id": "azteca-mexico-city",
      "home": "UZB",
      "away": "COL",
      "revision": 1,
      "score": "1-3"
    },
    {
      "id": "wc26-m063",
      "stage": "group",
      "group": "K",
      "kickoff_utc": "2026-06-23T17:00:00Z",
      "venue_id": "nrg-houston",
      "home": "POR",
      "away": "UZB",
      "revision": 1,
      "score": "5-0"
    },
    {
      "id": "wc26-m064",
      "stage": "group",
      "group": "K",
      "kickoff_utc": "2026-06-24T02:00:00Z",
      "venue_id": "akron-guadalajara",
      "home": "COD",
      "away": "COL",
      "revision": 1,
      "score": "0-1"
    },
    {
      "id": "wc26-m065",
      "stage": "group",
      "group": "K",
      "kickoff_utc": "2026-06-27T23:30:00Z",
      "venue_id": "hard-rock-miami",
      "home": "COL",
      "away": "POR",
      "revision": 1,
      "score": "0-0"
    },
    {
      "id": "wc26-m066",
      "stage": "group",
      "group": "K",
      "kickoff_utc": "2026-06-27T23:30:00Z",
      "venue_id": "mercedes-benz-atlanta",
      "home": "COD",
      "away": "UZB",
      "revision": 1,
      "score": "3-1"
    },
    {
      "id": "wc26-m067",
      "stage": "group",
      "group": "L",
      "kickoff_utc": "2026-06-17T20:00:00Z",
      "venue_id": "att-arlington",
      "home": "ENG",
      "away": "CRO",
      "revision": 1,
      "score": "4-2"
    },
    {
      "id": "wc26-m068",
      "stage": "group",
      "group": "L",
      "kickoff_utc": "2026-06-17T23:00:00Z",
      "venue_id": "bmo-toronto",
      "home": "GHA",
      "away": "PAN",
      "revision": 1,
      "score": "1-0"
    },
    {
      "id": "wc26-m069",
      "stage": "group",
      "group": "L",
      "kickoff_utc": "2026-06-23T20:00:00Z",
      "venue_id": "gillette-foxborough",
      "home": "ENG",
      "away": "GHA",
      "revision": 1,
      "score": "0-0"
    },
    {
      "id": "wc26-m070",
      "stage": "group",
      "group": "L",
      "kickoff_utc": "2026-06-23T23:00:00Z",
      "venue_id": "bmo-toronto",
      "home": "CRO",
      "away": "PAN",
      "revision": 1,
      "score": "1-0"
    },
    {
      "id": "wc26-m071",
      "stage": "group",
      "group": "L",
      "kickoff_utc": "2026-06-27T21:00:00Z",
      "venue_id": "metlife-east-rutherford",
      "home": "PAN",
      "away": "ENG",
      "revision": 1,
      "score": "0-2"
    },
    {
      "id": "wc26-m072",
      "stage": "group",
      "group": "L",
      "kickoff_utc": "2026-06-27T21:00:00Z",
      "venue_id": "lincoln-philadelphia",
      "home": "CRO",
      "away": "GHA",
      "revision": 1,
      "score": "2-1"
    },
    {
      "id": "wc26-m073",
      "stage": "r32",
      "kickoff_utc": "2026-06-28T19:00:00Z",
      "venue_id": "sofi-inglewood",
      "home": "RSA",
      "away": "CAN",
      "revision": 1,
      "score": "0-1"
    },
    {
      "id": "wc26-m074",
      "stage": "r32",
      "kickoff_utc": "2026-06-29T17:00:00Z",
      "venue_id": "nrg-houston",
      "home": "BRA",
      "away": "JPN",
      "revision": 1,
      "score": "2-1"
    },
    {
      "id": "wc26-m075",
      "stage": "r32",
      "kickoff_utc": "2026-06-30T01:00:00Z",
      "venue_id": "bbva-monterrey",
      "home": "NED",
      "away": "MAR",
      "revision": 1,
      "score": "3-4"
    },
    {
      "id": "wc26-m076",
      "stage": "r32",
      "kickoff_utc": "2026-07-02T00:00:00Z",
      "venue_id": "levi-santa-clara",
      "home": "USA",
      "away": "BIH",
      "revision": 1,
      "score": "2-0"
    },
    {
      "id": "wc26-m077",
      "stage": "r32",
      "kickoff_utc": "2026-06-29T20:30:00Z",
      "venue_id": "gillette-foxborough",
      "home": "GER",
      "away": "PAR",
      "revision": 2,
      "score": "4-5"
    },
    {
      "id": "wc26-m078",
      "stage": "r32",
      "kickoff_utc": "2026-06-30T17:00:00Z",
      "venue_id": "att-arlington",
      "home": "CIV",
      "away": "NOR",
      "revision": 1,
      "score": "1-2"
    },
    {
      "id": "wc26-m079",
      "stage": "r32",
      "kickoff_utc": "2026-06-30T21:00:00Z",
      "venue_id": "metlife-east-rutherford",
      "home": "FRA",
      "away": "SWE",
      "revision": 1,
      "score": "3-0"
    },
    {
      "id": "wc26-m080",
      "stage": "r32",
      "kickoff_utc": "2026-07-01T01:00:00Z",
      "venue_id": "azteca-mexico-city",
      "home": "MEX",
      "away": "ECU",
      "revision": 1,
      "score": "2-0"
    },
    {
      "id": "wc26-m081",
      "stage": "r32",
      "kickoff_utc": "2026-07-01T16:00:00Z",
      "venue_id": "mercedes-benz-atlanta",
      "home": "ENG",
      "away": "COD",
      "revision": 1,
      "score": "2-1"
    },
    {
      "id": "wc26-m082",
      "stage": "r32",
      "kickoff_utc": "2026-07-01T20:00:00Z",
      "venue_id": "century-link-seattle",
      "home": "BEL",
      "away": "SEN",
      "revision": 1,
      "score": "3-2"
    },
    {
      "id": "wc26-m083",
      "stage": "r32",
      "kickoff_utc": "2026-07-02T19:00:00Z",
      "venue_id": "sofi-inglewood",
      "home": "ESP",
      "away": "AUT",
      "revision": 1,
      "score": "3-0"
    },
    {
      "id": "wc26-m084",
      "stage": "r32",
      "kickoff_utc": "2026-07-02T23:00:00Z",
      "venue_id": "bmo-toronto",
      "home": "POR",
      "away": "CRO",
      "revision": 1,
      "score": "2-1"
    },
    {
      "id": "wc26-m085",
      "stage": "r32",
      "kickoff_utc": "2026-07-03T03:00:00Z",
      "venue_id": "bc-place-vancouver",
      "home": "SUI",
      "away": "ALG",
      "revision": 1,
      "score": "2-0"
    },
    {
      "id": "wc26-m086",
      "stage": "r32",
      "kickoff_utc": "2026-07-03T18:00:00Z",
      "venue_id": "att-arlington",
      "home": "AUS",
      "away": "EGY",
      "revision": 1,
      "score": "3-5"
    },
    {
      "id": "wc26-m087",
      "stage": "r32",
      "kickoff_utc": "2026-07-03T22:00:00Z",
      "venue_id": "hard-rock-miami",
      "home": "ARG",
      "away": "CPV",
      "revision": 1,
      "score": "3-2"
    },
    {
      "id": "wc26-m088",
      "stage": "r32",
      "kickoff_utc": "2026-07-04T01:30:00Z",
      "venue_id": "arrowhead-kansas-city",
      "home": "COL",
      "away": "GHA",
      "revision": 1,
      "score": "1-0"
    },
    {
      "id": "wc26-m089",
      "stage": "r16",
      "kickoff_utc": "2026-07-04T17:00:00Z",
      "venue_id": "nrg-houston",
      "home": "CAN",
      "away": "MAR",
      "revision": 1,
      "score": "0-3"
    },
    {
      "id": "wc26-m090",
      "stage": "r16",
      "kickoff_utc": "2026-07-04T21:00:00Z",
      "venue_id": "lincoln-philadelphia",
      "home": "PAR",
      "away": "FRA",
      "revision": 1,
      "score": "0-1"
    },
    {
      "id": "wc26-m091",
      "stage": "r16",
      "kickoff_utc": "2026-07-05T20:00:00Z",
      "venue_id": "metlife-east-rutherford",
      "home": "BRA",
      "away": "NOR",
      "revision": 1,
      "score": "1-2"
    },
    {
      "id": "wc26-m092",
      "stage": "r16",
      "kickoff_utc": "2026-07-06T00:00:00Z",
      "venue_id": "azteca-mexico-city",
      "home": "MEX",
      "away": "ENG",
      "revision": 1,
      "score": "2-3"
    },
    {
      "id": "wc26-m093",
      "stage": "r16",
      "kickoff_utc": "2026-07-07T00:00:00Z",
      "venue_id": "century-link-seattle",
      "home": "USA",
      "away": "BEL",
      "revision": 1,
      "score": "1-4"
    },
    {
      "id": "wc26-m094",
      "stage": "r16",
      "kickoff_utc": "2026-07-06T19:00:00Z",
      "venue_id": "att-arlington",
      "home": "POR",
      "away": "ESP",
      "revision": 1,
      "score": "0-1"
    },
    {
      "id": "wc26-m095",
      "stage": "r16",
      "kickoff_utc": "2026-07-07T16:00:00Z",
      "venue_id": "mercedes-benz-atlanta",
      "home": "ARG",
      "away": "EGY",
      "revision": 1,
      "score": "3-2"
    },
    {
      "id": "wc26-m096",
      "stage": "r16",
      "kickoff_utc": "2026-07-07T20:00:00Z",
      "venue_id": "bc-place-vancouver",
      "home": "SUI",
      "away": "COL",
      "revision": 2,
      "score": "4-3"
    },
    {
      "id": "wc26-m097",
      "stage": "qf",
      "kickoff_utc": "2026-07-09T20:00:00Z",
      "venue_id": "gillette-foxborough",
      "home": "FRA",
      "away": "MAR",
      "revision": 1,
      "score": "2-0"
    },
    {
      "id": "wc26-m098",
      "stage": "qf",
      "kickoff_utc": "2026-07-11T21:00:00Z",
      "venue_id": "hard-rock-miami",
      "home": "NOR",
      "away": "ENG",
      "revision": 1,
      "score": "1-2"
    },
    {
      "id": "wc26-m099",
      "stage": "qf",
      "kickoff_utc": "2026-07-10T19:00:00Z",
      "venue_id": "sofi-inglewood",
      "home": "ESP",
      "away": "BEL",
      "revision": 1,
      "score": "2-1"
    },
    {
      "id": "wc26-m100",
      "stage": "qf",
      "kickoff_utc": "2026-07-12T01:00:00Z",
      "venue_id": "arrowhead-kansas-city",
      "home": "ARG",
      "away": "SUI",
      "revision": 1,
      "score": "3-1"
    },
    {
      "id": "wc26-m101",
      "stage": "sf",
      "kickoff_utc": "2026-07-14T19:00:00Z",
      "venue_id": "att-arlington",
      "home": "FRA",
      "away": "ESP",
      "revision": 1,
      "score": "0-2"
    },
    {
      "id": "wc26-m102",
      "stage": "sf",
      "kickoff_utc": "2026-07-15T19:00:00Z",
      "venue_id": "mercedes-benz-atlanta",
      "home": "ENG",
      "away": "ARG",
      "revision": 1,
      "score": "1-2"
    },
    {
      "id": "wc26-m103",
      "stage": "3rd",
      "kickoff_utc": "2026-07-18T21:00:00Z",
      "venue_id": "hard-rock-miami",
      "home": "FRA",
      "away": "ENG",
      "revision": 1,
      "score": "4-6"
    },
    {
      "id": "wc26-m104",
      "stage": "final",
      "kickoff_utc": "2026-07-19T19:00:00Z",
      "venue_id": "metlife-east-rutherford",
      "home": "ESP",
      "away": "ARG",
      "revision": 1,
      "score": "1-0"
    }
  ]
}
